export default __webpack_public_path__ + "static/media/pic60.7bc05034.jpg";